import type { ArdoqId } from '@ardoq/api-types';
import type { GraphGroup, GraphNode } from '@ardoq/graph';
import type { ViewModelSourceData } from '@ardoq/timeline2024';
import { uniq } from 'lodash';

/**
 * The view renders a depth-first walk from `startSetNodes`, which workspace mode
 * narrows to the root trees holding the context component. A node without a
 * `viewGraphHierarchy` entry renders no item, even when its parent still lists
 * it as a child.
 */
export const getTimelineViewComponentIds = ({
  fieldsAndItemsSourceData,
  viewRelevantComponentsScopeData,
}: Pick<
  ViewModelSourceData,
  'fieldsAndItemsSourceData' | 'viewRelevantComponentsScopeData'
>): ArdoqId[] => {
  const { viewGraphHierarchy, startSetNodes } = fieldsAndItemsSourceData;

  const componentIds = (nodes: (GraphGroup | GraphNode)[]): ArdoqId[] =>
    nodes.flatMap(node => {
      const hierarchyNode = viewGraphHierarchy.get(node.id);
      if (!hierarchyNode) return [];
      const ownComponentId = viewRelevantComponentsScopeData.has(node.modelId)
        ? [node.modelId]
        : [];
      return [...ownComponentId, ...componentIds(hierarchyNode.children)];
    });

  return uniq(componentIds(startSetNodes));
};
